import { render, staticRenderFns } from "./SideBarProgress.vue?vue&type=template&id=6360a82a"
import script from "./SideBarProgress.vue?vue&type=script&lang=js"
export * from "./SideBarProgress.vue?vue&type=script&lang=js"
import style0 from "./SideBarProgress.vue?vue&type=style&index=0&id=6360a82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports